import React, { useState, useEffect } from "react";
import OfficialInformationStyles from "./OfficialInformation.styles";
import {
  Box,
  Checkbox,
  Dialog,
  Divider,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import YhInput from "../../../../../ui/YhInput";
import YhSelect from "../../../../../ui/YhSelect";
import YhButton from "../../../../../ui/YhButton";
import {
  getOfficeDetails,
  saveOfficialInfo,
  updateOfficailInfo,
} from "../StepperService";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import notifiers from "../../../../../global/constants/NotificationConstants";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../../helpers/methods";
import CustomLoader from "../../../../../global/components/CustomLoader/CustomLoader";
import { getAllDepartment, getAllDesignation, getReportingManager, getTeamByDepartment, getProjectsByTeam, assignUserToTeamProjects } from "./OfficialInfoService";
import {
  getAllSalesHead,
  getAllManagerByTeamWise,
  getTeamList,
  getAllManagerByRole,
} from "../../../../MetaData/components/MetaList/components/AddTeamMetaList/CreateService";
import { getRoleById, getPerosnalDetails } from "../StepperService";
import { getFinalBodyStructure, handleValidation, initialState } from "./ValidatorOffice";
import { getAllHierarchyMeta } from "../../../../MetaData/components/MetaList/components/CompanyHierarchyList/companyHierarchyService";
import MetaListStyles from "../../../../MetaData/components/MetaList/MetaList.styles";
import CustomPageHeaderStyles from "../../../../../global/components/CustomPageHeader/CustomPageHeader.styles";
const _ = require("lodash");

interface CustomProps {
  nextStep?: () => void | undefined;
  backStep?: () => void | undefined;
  userId: String;
  fromSettingOrLogout?: any;
  registerStepActions?: (actions: { submit: () => void | Promise<void> }) => void;
  hideFooterButtons?: boolean;
}

const EmployTypeoptions: any = ["Full Time", "Part Time", "Freelancer"];

const RolePermissions: any = ["HR Admin", "Admin", "Manager", "User"];

let clonedObject = {};

const OfficialInformation = (props: CustomProps) => {
  const classes = OfficialInformationStyles;
  const [inputValue, setInputValue] = React.useState("");
  const [dataFlag, setDataFlag] = React.useState<Number>(0);
  const [apiResponse, setApiResponse] = useState(false);
  const [role, setRole] = useState<any>([]);
  const [teamList, setTeamList] = useState<any>([]);
  const [headList, setHeadList] = useState<any>([]);
  const [departmentOption, setDepartmentOption] = useState([]);
  const [degination, setDegination] = useState([]);
  const [officialDetailState, setofficialDetailState] = useState<any>(
    initialState({})
  );

  const [departmentId, setDepartmentId] = useState("");
  // const [teamList, setTeamList] = useState<any>([]);

  console.log(officialDetailState, "officialDetailStateofficialDetailStateofficialDetailState");
  const [hierarchyData, setHierarchyData] = useState<any>([]);
  const [openTeamModal, setOpenTeamModal] = React.useState(false);
  const [selectedTeam, setSelectedTeam] = useState<any>([]);
  const [teamData, setTeamData] = useState<any>([]);
  const [teamRole, setTeamRole] = useState<any>([]);
  const [reportingManagerData, setReportingManagerData] = useState<any>([]);
  const [memberName, setMemberName] = useState("");
  const [assignTeamProjects, setAssignTeamProjects] = useState(true);
  const [teamProjects, setTeamProjects] = useState<
    Array<{ _id: string; project_name: string; assigned?: boolean }>
  >([]);
  const [selectedProjectIds, setSelectedProjectIds] = useState<string[]>([]);
  const [initialProjectIds, setInitialProjectIds] = useState<string[]>([]);
  const [initialAssignTeamProjects, setInitialAssignTeamProjects] =
    useState(true);
  const [loadingProjects, setLoadingProjects] = useState(false);

  console.log(teamData, "teamData:::::::::::")
  const initialWeekdaysState = {
    sunday: true,
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: true,
  };

  const initalShipt = {
    day: true,
    night: true,
  };
  const [weekdaysState, setWeekdaysState] = useState(initialWeekdaysState);
  // const [workingShiftState, setWorkingShiftState] = useState(initalShipt);

  useEffect(() => {
    init();
    // Preload departments on add/edit so the dropdown is ready on focus.
    (async () => {
      try {
        const response = await getAllDepartment();
        if (Array.isArray(response?.data)) {
          setDepartmentOption(
            response.data.map((department: any) => ({
              _id: department._id,
              department_name: department.department_name,
            }))
          );
        }
      } catch (_) {
        /* ignore */
      }
    })();
  }, []);

  const rebuildTeamRoles = (
    teams: any[],
    selected: Array<{ id: any; value?: string }>
  ) => {
    if (!selected?.length || !teams?.length) {
      setTeamRole([]);
      return [];
    }
    const flatTeams = teams.flatMap((item: any) => [
      item,
      ...(item.sub_teams || []),
    ]);
    const roleMap = new Map<string, any>();
    selected.forEach((sel) => {
      const selId = String(sel?.id || "");
      flatTeams
        .filter((team: any) => String(team._id || team.id) === selId)
        .forEach((team: any) => {
          (team.teamRole || []).forEach((role: any) => {
            const rid = String(role.id || role._id || "");
            if (rid && !roleMap.has(rid)) {
              roleMap.set(rid, {
                id: rid,
                role: role.role || role.label || role.hierarchyName || "",
                hierarchyLevel: role.hierarchyLevel,
              });
            }
          });
        });
    });
    const roles = Array.from(roleMap.values());
    setTeamRole(roles);
    return roles;
  };

  // Rebuild role options whenever selected teams OR team meta loads
  useEffect(() => {
    rebuildTeamRoles(teamData, selectedTeam);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTeam, teamData]);

  useEffect(() => {
    if (officialDetailState.hierarchyId?.id) {
      (async () => {
        const response = await getReportingManager(
          officialDetailState.hierarchyId?.id
        );
        setReportingManagerData(
          response.data?.map((i: any) => {
            return { id: i._id, label: i.name };
          })
        );
      })();
    } else if (officialDetailState.teamRoleId?.id) {
      (async () => {
        const response = await getReportingManager(
          officialDetailState.teamRoleId?.id
        );
        setReportingManagerData(
          response.data?.map((i: any) => {
            return { id: i._id, label: i.name };
          })
        );
      })();
    }
  }, [
    officialDetailState.hierarchyId?.id,
    officialDetailState.teamRoleId?.id,
  ]);

  useEffect(() => {
    if (!departmentId) return;
    let cancelled = false;
    (async () => {
      try {
        const teamResponse = await getTeamByDepartment(departmentId);
        if (!cancelled) setTeamData(teamResponse.data || []);
      } catch (_) {
        /* ignore */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [departmentId]);


  // Designation reset is handled directly in handleAutocompleteChange("department")
  // to avoid race conditions with init() hydration.
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  // const handleParentTeam = (team: any) => {
  //   console.log(team, "teammmmmmmmmmmmmmmmmmmmmmm")
  //   setSelectedTeam(team._id);
  //   setofficialDetailState({
  //     ...officialDetailState,
  //     team_id:{

  //       value: team.team_name,
  //       id: team._id
  //     }


  //   })
  //   setOpenTeamModal(false)
  // };

  const handleParentTeam = (team: any) => {
    console.log(team, "teammmmmmmmmmmmmmmmmmmmmmm");
    const isAlreadySelected = selectedTeam.some((selected: { id: any; }) => selected.id === team._id);

    let updatedSelectedTeams;
    if (isAlreadySelected) {
      // Remove the team if it's already selected
      updatedSelectedTeams = selectedTeam.filter((selected: { id: any; }) => selected.id !== team._id);
    } else {
      // Add the team to the selected list
      updatedSelectedTeams = [
        ...selectedTeam,
        {
          id: team._id,
          value: team.team_name,
        },
      ];
    }

    setSelectedTeam(updatedSelectedTeams);

    setofficialDetailState({
      ...officialDetailState,
      team_id: updatedSelectedTeams.map((team:any) => team.id),
    });
  };

  useEffect(() => {
    if (!props.userId) {
      setMemberName("");
      return;
    }
    let cancelled = false;
    getPerosnalDetails(props.userId)
      .then((res: any) => {
        if (cancelled) return;
        setMemberName(String(res?.data?.name || res?.data?.userName || "").trim());
      })
      .catch(() => {
        if (!cancelled) setMemberName("");
      });
    return () => {
      cancelled = true;
    };
  }, [props.userId]);

  useEffect(() => {
    const teamIds = (selectedTeam || [])
      .map((team: any) => String(team.id || "").trim())
      .filter(Boolean);
    if (!teamIds.length) {
      setTeamProjects([]);
      setSelectedProjectIds([]);
      return;
    }
    let cancelled = false;
    setLoadingProjects(true);
    getProjectsByTeam(teamIds, String(props.userId || ""))
      .then((res: any) => {
        if (cancelled) return;
        const rows = Array.isArray(res?.data) ? res.data : [];
        setTeamProjects(rows);
        const already = rows
          .filter((row: any) => row.assigned)
          .map((row: any) => String(row._id));
        // Only pre-check projects already assigned to this member.
        // Do not auto-select every team project — that looked "saved" without persisting.
        setSelectedProjectIds(already);
        setInitialProjectIds(already);
        setAssignTeamProjects(true);
        setInitialAssignTeamProjects(true);
      })
      .catch(() => {
        if (cancelled) return;
        setTeamProjects([]);
        setSelectedProjectIds([]);
        setInitialProjectIds([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingProjects(false);
      });
    return () => {
      cancelled = true;
    };
  }, [JSON.stringify((selectedTeam || []).map((t: any) => t.id)), props.userId]);

  // const renderTeams = (teams: any[], level = 0) => {
  //   return teams.map((team) => {
  //     const isChecked = selectedTeam.some((selected: { id: any; }) => selected.id === team._id);
  //     return (
  //       <>
  //         <Box
  //           display="flex"
  //           justifyContent="flex-start"
  //           alignItems="center"
  //           mb={1}
  //           pl={2}
  //           style={{ paddingLeft: team.parentTeamId ? 30 : 0 }}
  //         >
  //           <Typography variant="body1" mr={2}>
  //             {team.team_name}
  //           </Typography>
  //           <FormControlLabel
  //             control={<Checkbox checked={isChecked} />}
  //             label=""
  //             value={team._id}
  //             style={{ marginLeft: "auto" }}
  //             onClick={() => handleParentTeam(team)}
  //           />
  //         </Box>

  //         <Box key={team._id} style={{ paddingLeft: team.parentTeamId ? 20 : 0 }}>
  //           {team.sub_teams && team.sub_teams.length > 0 && renderTeams(team.sub_teams, level + 1)}
  //         </Box>
  //       </>
  //     );
  //   });
  // };

  const renderTeams = (teams: any[], level = 0) => {
    return teams.map((team) => {
      const isChecked = selectedTeam.some((selected: { id: any }) => selected.id === team._id);
      const hasSubTeams = team.sub_teams && team.sub_teams.length > 0;
  
      return (
        <Box key={team._id} style={{ paddingLeft: team.parentTeamId ? 15 : 0 }}>
          <Box
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
            // mb={0}
            pl={1}
            style={{ paddingLeft: team.parentTeamId ? 30 : 0 }}
          >
            <Typography variant="body1" mr={1} style={{ fontSize: "12px" }}>
              {team.team_name}
            </Typography>
  
            {/* Only render checkbox for teams that do NOT have sub-teams */}
            {!hasSubTeams && (
              <FormControlLabel
                control={<Checkbox checked={isChecked} />}
                label=""
                value={team._id}
                style={{ marginLeft: "auto" }}
                onClick={() => handleParentTeam(team)}
              />
            )}
          </Box>
  
          {/* Recursively render sub-teams */}
          {hasSubTeams && renderTeams(team.sub_teams, level + 1)}
        </Box>
      );
    });
  };
  

  const handleOnChangeInputField = (event: React.ChangeEvent<any>) => {
    setofficialDetailState({
      ...officialDetailState,
      [event.target.name]: { value: event.target.value, error: "" },
    });
  };

  const handleAutocompleteChange = async (name: string, value: any) => {
    if (name === "role_id") {
      setofficialDetailState((prevFormData: any) => ({
        ...prevFormData,
        team_id: {
          error: "",
          value: "",
          id: "",
        },
        reporting_manager: {
          error: "",
          value: "",
          id: "",
        },
        [name]: {
          error: "",
          value: value.role_name,
          id: value.role_id,
        },
      }));
      console.log(
        value.role_name.toLowerCase(),
        "value.role_name.toLowerCase()"
      );
      // if (value.role_name.toLowerCase() == "team-lead") {
      //   const response = await getTeamList();
      //   customErrorHandler(response);
      //   setTeamList(
      //     response?.data.map((e: any) => {
      //       return {
      //         team_id: e?._id,
      //         team_name: e?.team_name,
      //       };
      //     })
      //   );
      //   const response1 = await getAllSalesHead();
      //   customErrorHandler(response1);
      //   setHeadList(
      //     response1?.data.map((e: any) => {
      //       return {
      //         id: e._id,
      //         reporting_manager_name: e.name,
      //       };
      //     })
      //   );
      // } else if (value.role_name.toLowerCase() == "executive") {
      //   const response = await getTeamList();
      //   customErrorHandler(response);
      //   setTeamList(
      //     response?.data.map((e: any) => {
      //       return {
      //         team_id: e?._id,
      //         team_name: e?.team_name,
      //       };
      //     })
      //   );
      // } else {
      //   const response = await getAllManagerByRole(value.role_id);
      //   customErrorHandler(response);
      //   setHeadList(
      //     response?.data.map((e: any) => {
      //       return {
      //         id: e?._id,
      //         reporting_manager_name: e?.name,
      //       };
      //     })
      //   );
      //   setTeamList([]);
      //   // setHeadList([]);
      // }
    } else if (name === "team_id") {
      setofficialDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: {
          error: "",
          value: value.team_name,
          id: value.team_id,
        },
      }));
      if (String(officialDetailState?.role_id?.value || "").toLowerCase() == "executive") {
        setofficialDetailState((prevFormData: any) => ({
          ...prevFormData,
          reporting_manager: {
            error: "",
            value: "",
            id: "",
          },
        }));
        // const response = await getAllManagerByTeamWise(value.team_id);
        // customErrorHandler(response);
        // setHeadList(
        //   response?.data.map((e: any) => {
        //     return {
        //       id: e.id,
        //       reporting_manager_name: e?.user_name,
        //     };
        //   })
        // );
      }
    } else if (name === "reporting_manager") {
      console.log(value, "dynamic");
      setofficialDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: {
          error: "",
          value: value.reporting_manager_name,
          id: value.id,
        },
      }));
    }
    else if (name === "department") {
      setDepartmentId(value._id);
      setDegination([]);
      setofficialDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: {
          error: "",
          value: value.department_name,
          id: value._id,
        },
        designation: { id: "", value: "", error: "" },
      }));
    }
    else if (name === "designation") {
      setofficialDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: {
          error: "",
          value: value.designation_name,
          id: value._id,
        },
      }));
    }

    else {
      setofficialDetailState((prevState: any) => ({
        ...prevState,
        [name]: {
          value: value ?? "",
          error: "",
        },
      }));
    }
  };
  const onClickAutoComplete = async (type: any) => {
    if (type === "department") {
      if (departmentOption && departmentOption.length > 0) return;
      try {
        const response = await getAllDepartment();
        customErrorHandler(response);
        const updatedOptions = response.data.map((department: any) => ({
          _id: department._id,
          department_name: department.department_name,
        }));
        setDepartmentOption(updatedOptions);
      } catch (error: any) {
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }

    if (type === "designation") {
      if (degination && degination.length > 0) return;

      try {
        setApiResponse(true);
        const response = await getAllDesignation(departmentId);
        const updatedDesignation = response.data.map((designation: any) => ({
          _id: designation._id,
          designation_name: designation.designation_name,
        }));
        setDegination(updatedDesignation);
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }
    if (type === "team List") {
      if (teamData && teamData.length > 0) return;

      try {
        setApiResponse(true);
        const response = await getTeamByDepartment(departmentId);
        const rows = Array.isArray(response?.data) ? response.data : [];
        setTeamData(rows);
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
      }
    }

  };


  const handleCheckboxChange = (event: any, key = "") => {
    const name: any = event.target.name;
    const checked: any = event.target.checked;
    setofficialDetailState((prevState: any) => {
      const current = Array.isArray(prevState?.[key]?.value)
        ? [...prevState[key].value]
        : [];
      const next = checked
        ? current.includes(name)
          ? current
          : [...current, name]
        : current.filter((shift: string) => shift != name);
      return {
        ...prevState,
        [key]: {
          value: next,
          error: "",
        },
      };
    });
  };

  const handleBackBtn = () => {
    props.backStep?.();
  };

  const init = async () => {
    if (props.userId) {
      try {
        setApiResponse(true);
        const [response, hierarchyResponse, deptRes] = await Promise.all([
          getOfficeDetails(props.userId),
          getAllHierarchyMeta(),
          getAllDepartment(),
        ]);
        setDataFlag(response.success ?? 0);
        const orgHierarchyData = (hierarchyResponse.data || []).filter(
          (item: any) => item.isOrganization === 1
        );
        setHierarchyData(
          orgHierarchyData.map((i: any) => {
            return {
              id: i._id,
              label: i.hierarchyName,
              hierarchyLevel: i.hierarchyLevel,
            };
          })
        );

        customErrorHandler(response);
        const office = response.data || {};
        let nextState = initialState(office);

        // Resolve department id from name so Department select + team fetch work on edit
        try {
          const depts = deptRes?.data || [];
          setDepartmentOption(
            depts.map((department: any) => ({
              _id: department._id,
              department_name: department.department_name,
            }))
          );
          const match = depts.find(
            (d: any) =>
              String(d._id) ===
                String(office.departmentId || office.department_id || "") ||
              String(d.department_name || "").toLowerCase() ===
                String(office.department || "").toLowerCase()
          );
          if (match) {
            nextState = {
              ...nextState,
              department: {
                ...nextState.department,
                id: match._id,
                value: match.department_name,
                error: "",
              },
            };
            const [teamResponse, desigRes] = await Promise.all([
              getTeamByDepartment(match._id),
              getAllDesignation(String(match._id)),
            ]);
            setTeamData(teamResponse?.data || []);

            try {
              const desigList = (desigRes?.data || []).map((d: any) => ({
                _id: d._id,
                designation_name: d.designation_name,
              }));
              setDegination(desigList);
              const savedDesigName = String(
                office.designation || ""
              ).toLowerCase();
              if (savedDesigName) {
                const desigMatch = desigList.find(
                  (d: any) =>
                    String(d.designation_name || "").toLowerCase() ===
                    savedDesigName
                );
                if (desigMatch) {
                  nextState = {
                    ...nextState,
                    designation: {
                      value: desigMatch.designation_name,
                      id: desigMatch._id,
                      error: "",
                    },
                  };
                }
              }
            } catch (_) {
              /* designation hydrate best-effort */
            }

            setDepartmentId(String(match._id));
          }
        } catch (_) {
          /* department hydrate best-effort */
        }

        setofficialDetailState(nextState);
        let rawTeamIds: any = office.team_id;
        if (typeof rawTeamIds === "string") {
          try {
            const parsed = JSON.parse(rawTeamIds);
            rawTeamIds = parsed;
          } catch {
            rawTeamIds = rawTeamIds.trim() ? [rawTeamIds] : [];
          }
        }
        rawTeamIds = Array.isArray(rawTeamIds)
          ? rawTeamIds
          : rawTeamIds
            ? [rawTeamIds]
            : [];
        // Drop invalid / nested-array junk like "[]"
        rawTeamIds = rawTeamIds
          .map((id: any) => String(id || "").trim())
          .filter(
            (id: string) =>
              id && id !== "[]" && id !== "null" && id !== "undefined"
          );

        const rawTeamNames = Array.isArray(office.team_name)
          ? office.team_name
          : office.team_name
            ? [office.team_name]
            : [];

        const hydratedSelectedTeam = rawTeamIds.map(
          (id: any, index: number) => ({
            id: String(id),
            value: String(rawTeamNames[index] || ""),
          })
        );

        setSelectedTeam(hydratedSelectedTeam);

        clonedObject = _.cloneDeep(nextState);
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        {
          if (
            isTruthy(error.message) &&
            error.message.toLowerCase() === "data not found"
          )
            return;
          else
            openErrorNotification(
              isTruthy(error.message ? error.message : notifiers.GENERIC_ERROR)
            );
        }
      }
    }
  };

  // submit method
  //   const submitForm = async () => {
  //     const validatedObject: any = handleValidation(officialDetailState);
  //     console.log(validatedObject, "validatedObject:::::::::::")
  //     // if (
  //     //   validatedObject?.joining.error ||
  //     //   validatedObject?.emp_type.error ||
  //     //   validatedObject?.team_id.error ||
  //     //   validatedObject?.role_id.error ||

  //     //   validatedObject?.reporting_manager.error ||
  //     //   validatedObject?.department.error ||
  //     //   validatedObject?.designation.error

  //     // ) {
  //     //   setofficialDetailState({ ...validatedObject });
  //     //   return;
  //     // }
  //     if (
  //       props.userId &&
  //       _.isEqual(clonedObject, officialDetailState) &&
  //       dataFlag
  //     ) {
  //       props.nextStep?.();
  //     } else if (props.userId && dataFlag) {
  //       try {
  //         setApiResponse(true);
  //         const body = {
  //           ...officialDetailState,
  //           userId: { value: props.userId, error: "" },
  //           team_name: {
  //             value: officialDetailState?.team_id.value ?? "",
  //             error: "",
  //           },
  //         };
  // console.log(body,"payload:::::::::::::::::::")
  //         const response = await updateOfficailInfo(getFinalBodyStructure(body));
  //         if (response?.success) {
  //           setofficialDetailState(response.data);
  //           openSuccessNotification(response?.message);
  //           props.nextStep?.();
  //         } else {
  //           customErrorHandler(response);
  //         }
  //         setApiResponse(false);
  //       } catch (error: any) {
  //         setApiResponse(false);
  //         openErrorNotification(
  //           isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
  //         );
  //       }
  //     } else {

  //       try {
  //         setApiResponse(true);
  //         const body = {
  //           ...officialDetailState,
  //           userId: { value: props.userId, error: "" },
  //         };
  //         console.log("body", body);
  //         console.log("getFinalBodyStructure(body)", getFinalBodyStructure(body));
  //         const response = await saveOfficialInfo(getFinalBodyStructure(body));
  //         if (response?.success) {
  //           setofficialDetailState(response.data);
  //           openSuccessNotification(response?.message);
  //           props.nextStep?.();
  //         } else {
  //           customErrorHandler(response);
  //         }
  //         setApiResponse(false);
  //       } catch (error: any) {
  //         setApiResponse(false);
  //         openErrorNotification(
  //           isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
  //         );
  //       }
  //     }
  //   };




  const submitForm = async () => {
    const validatedObject: any = handleValidation(officialDetailState);
    if (
      validatedObject?.joining.error ||
      validatedObject?.emp_type.error) {
      setofficialDetailState({ ...validatedObject });
      return;
    }

    const sorted = (ids: string[]) => [...ids].map(String).sort();
    const projectsDirty =
      assignTeamProjects !== initialAssignTeamProjects ||
      !_.isEqual(sorted(selectedProjectIds), sorted(initialProjectIds));
    const officeDirty =
      !(
        props.userId &&
        dataFlag &&
        !_.isEmpty(clonedObject) &&
        _.isEqual(clonedObject, officialDetailState)
      );

    // No office or project edits — just continue
    if (props.userId && dataFlag && !officeDirty && !projectsDirty) {
      props.nextStep?.();
      return;
    }

    const body = {
      userId: props.userId,
      emp_type: officialDetailState?.emp_type?.value,
      joining: officialDetailState?.joining?.value,
      dor: officialDetailState?.dor?.value,
      hierarchyId:
        officialDetailState?.hierarchyId?.id ||
        officialDetailState?.teamRoleId?.id,
      team_id:
        Array.isArray(officialDetailState?.team_id) &&
        officialDetailState.team_id.length > 0
          ? JSON.stringify(officialDetailState.team_id)
          : Array.isArray(selectedTeam) && selectedTeam.length > 0
            ? JSON.stringify(selectedTeam.map((t: any) => t.id))
            : null,

      // team_id: JSON.stringify(officialDetailState?.team_id ? (officialDetailState.team_id || [])?.map((item: any) => item) : []),

      department: officialDetailState?.department?.value,
      designation: officialDetailState?.designation?.value || "",
      teamRoleId: officialDetailState?.teamRoleId?.id || "",
      teamRoleName: officialDetailState?.teamRoleName?.value || "",
      working_days: (officialDetailState?.working_days?.value || []).join(","),
      working_shift: (officialDetailState?.working_shift?.value || []).join(
        ","
      ),
      hierarchyLevel:
        officialDetailState?.hierarchyId?.hierarchyLevel ||
        officialDetailState?.teamRoleId?.hierarchyLevel,
      reportingManagerId: officialDetailState?.reportingManagerId?.id,
      reportingManagerName: officialDetailState?.reportingManagerName?.value,
      isOrganization: officialDetailState?.isOrganization?.value ?? 0,
      id: officialDetailState?.id?.value,
    };

    let officeOk = !officeDirty;
    if (officeDirty) {
      const response =
        props.userId && dataFlag
          ? await updateOfficailInfo(body)
          : await saveOfficialInfo(body);
      officeOk = response?.success === 1;
      if (!officeOk) {
        openErrorNotification(
          response?.message || "Failed to save official details"
        );
        return;
      }
      clonedObject = _.cloneDeep(officialDetailState);
    }

    if (projectsDirty && props.userId) {
      try {
        const teamProjectIds = teamProjects.map((row) => String(row._id));
        // Always persist adds/removes. Unchecking the master toggle clears all.
        const projectIds = assignTeamProjects ? selectedProjectIds : [];
        const unassignProjectIds = assignTeamProjects
          ? teamProjectIds.filter((id) => !selectedProjectIds.includes(id))
          : teamProjectIds;
        const assignRes = await assignUserToTeamProjects({
          userId: String(props.userId),
          assign: true,
          projectIds,
          unassignProjectIds,
        });
        if (!(assignRes?.success === 1 || assignRes?.success === true)) {
          openErrorNotification(
            assignRes?.message ||
              "Official details saved, but project assignment failed"
          );
          return;
        }
        setInitialProjectIds([...projectIds]);
        setInitialAssignTeamProjects(assignTeamProjects);
      } catch (assignErr: any) {
        openErrorNotification(
          assignErr?.message ||
            "Official details saved, but project assignment failed"
        );
        return;
      }
    }

    if (officeOk) {
      openSuccessNotification(
        projectsDirty
          ? "Official details and project assignment saved"
          : "Official details saved successfully"
      );
      props.nextStep?.();
    }
  };

  useEffect(() => {
    props.registerStepActions?.({ submit: submitForm });
  });

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const inputs = document.getElementsByTagName("input");
      const currentIndex = Array.from(inputs).indexOf(
        event.target as HTMLInputElement
      );
      const nextIndex = currentIndex + 1;

      if (nextIndex < inputs.length) {
        inputs[nextIndex].focus();
      } else {
        // If the last input field is reached, trigger the submitForm function
        submitForm();
      }
    }
  };

  const dateToInput = (raw: string | null | undefined) => {
    if (!raw || typeof raw !== "string") return "";
    if (/^\d{4}-\d{2}-\d{2}/.test(raw)) return raw.slice(0, 10);
    const parts = raw.split(/[-/]/);
    if (parts.length === 3) {
      const [d, m, y] = parts;
      const year = y.length === 2 ? `20${y}` : y;
      return `${year}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
    }
    return "";
  };

  return (
    <>
      <div className="w-full">
        <div className="mb-5">
          <h2 className="text-lg font-semibold text-[#111827]">
            Official Information
          </h2>
          <p className="mt-1 text-sm text-[#6B7280]">
            Update your offcial information for the platform
          </p>
        </div>

        <div className="mb-6 mt-5">
          <h3 className="text-base font-semibold text-[#111827]">
            Official Details
          </h3>
          <p className="mt-1 text-sm text-[#6B7280]">
            {props.fromSettingOrLogout === "fromSettingOrLogout"
              ? "Manage your official information"
              : "Manage official information"}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <YhInput
            label="Joining Date"
            type="date"
            value={dateToInput(officialDetailState?.joining?.value)}
            error={officialDetailState?.joining?.error}
            name="joining"
            onChange={(e) => {
              const v = e.target.value;
              if (!v) {
                setofficialDetailState({
                  ...officialDetailState,
                  joining: { value: null, error: "" },
                });
                return;
              }
              const [y, m, d] = v.split("-");
              setofficialDetailState({
                ...officialDetailState,
                joining: { value: `${d}-${m}-${y}`, error: "" },
              });
            }}
            onKeyPress={handleKeyPress}
          />

          <YhInput
            label="Relieving Date"
            type="date"
            value={dateToInput(officialDetailState?.dor?.value)}
            name="dor"
            onChange={(e) => {
              const v = e.target.value;
              if (!v) {
                setofficialDetailState({
                  ...officialDetailState,
                  dor: null,
                });
                return;
              }
              const [y, m, d] = v.split("-");
              setofficialDetailState({
                ...officialDetailState,
                dor: `${d}-${m}-${y}`,
              });
            }}
            onKeyPress={handleKeyPress}
          />

          <YhSelect
            label="Employee Type"
            placeholder="Select employee type"
            value={officialDetailState?.emp_type?.value || ""}
            error={officialDetailState?.emp_type?.error}
            options={EmployTypeoptions.map((opt: string) => ({
              label: opt,
              value: opt,
            }))}
            onChange={(e) =>
              handleAutocompleteChange("emp_type", e.target.value || "")
            }
            onKeyPress={handleKeyPress as any}
          />

          <YhSelect
            label="Team/Organization"
            placeholder="Select"
            value={officialDetailState?.isOrganization?.value ?? 0}
            options={[
              { label: "Team", value: 0 },
              { label: "Organization", value: 1 },
            ]}
            onChange={(e) =>
              setofficialDetailState((prev: any) => ({
                ...prev,
                isOrganization: { value: Number(e.target.value) },
              }))
            }
          />

          {Number(officialDetailState?.isOrganization?.value) === 1 && (
            <YhSelect
              label="Org Hierarchy"
              placeholder="Select Hierarchy"
              value={officialDetailState.hierarchyId?.id || ""}
              options={hierarchyData.map((item: any) => ({
                label: item.label,
                value: item.id,
              }))}
              onChange={(e) => {
                const selected = hierarchyData.find(
                  (item: any) => item.id === e.target.value
                );
                setofficialDetailState({
                  ...officialDetailState,
                  hierarchyId: {
                    id: selected?.id,
                    value: selected?.label,
                    hierarchyLevel: selected?.hierarchyLevel,
                  },
                });
              }}
            />
          )}

          <YhSelect
            label="Department"
            placeholder="Select department"
            value={officialDetailState?.department?.id || ""}
            error={officialDetailState?.department?.error}
            options={(departmentOption as any[]).map((dept: any) => ({
              label: dept.department_name,
              value: dept._id,
            }))}
            onFocus={() => onClickAutoComplete("department")}
            onChange={(e) => {
              const selected =
                (departmentOption as any[]).find(
                  (dept: any) => dept._id === e.target.value
                ) || "";
              handleAutocompleteChange("department", selected);
            }}
            onKeyPress={handleKeyPress as any}
          />

          <YhSelect
            label="Designation"
            placeholder="Select designation"
            value={officialDetailState?.designation?.id || ""}
            error={officialDetailState?.designation?.error}
            options={(degination as any[]).map((item: any) => ({
              label: item.designation_name,
              value: item._id,
            }))}
            onFocus={() => onClickAutoComplete("designation")}
            onChange={(e) => {
              const selected =
                (degination as any[]).find(
                  (item: any) => item._id === e.target.value
                ) || "";
              handleAutocompleteChange("designation", selected);
            }}
            onKeyPress={handleKeyPress as any}
          />

          {Number(officialDetailState?.isOrganization?.value) === 0 && (
            <>
              <YhInput
                label="Team"
                placeholder="Select Team"
                value={
                  selectedTeam.length > 0
                    ? selectedTeam.map((team: any) => team.value).join(", ")
                    : ""
                }
                readOnly
                onClick={async () => {
                  if (departmentId && (!teamData || teamData.length === 0)) {
                    try {
                      const teamResponse = await getTeamByDepartment(departmentId);
                      setTeamData(teamResponse?.data || []);
                    } catch (_) {}
                  }
                  setOpenTeamModal(true);
                }}
              />

              <YhSelect
                label="Team Role"
                placeholder="Select role"
                value={
                  officialDetailState?.teamRoleId?.id
                    ? String(officialDetailState.teamRoleId.id)
                    : ""
                }
                options={(() => {
                  const opts: Array<{ label: string; value: string }> =
                    teamRole.map((role: any) => ({
                      label: role.role,
                      value: String(role.id),
                    }));
                  const currentId = officialDetailState?.teamRoleId?.id
                    ? String(officialDetailState.teamRoleId.id)
                    : "";
                  const currentName =
                    officialDetailState?.teamRoleName?.value || "";
                  // Keep saved role visible even if team meta hasn't loaded yet
                  if (
                    currentId &&
                    !opts.some(
                      (o: { label: string; value: string }) =>
                        String(o.value) === currentId
                    )
                  ) {
                    opts.unshift({
                      label: currentName || "Current role",
                      value: currentId,
                    });
                  }
                  return opts;
                })()}
                onChange={(e) => {
                  const selected = teamRole.find(
                    (role: any) => String(role.id) === String(e.target.value)
                  );
                  setofficialDetailState({
                    ...officialDetailState,
                    teamRoleId: {
                      id: selected?.id || e.target.value,
                      hierarchyLevel: selected?.hierarchyLevel,
                    },
                    teamRoleName: {
                      value:
                        selected?.role ||
                        officialDetailState?.teamRoleName?.value ||
                        "",
                    },
                  });
                }}
              />

              {selectedTeam.length > 0 && (
                <div className="lg:col-span-2 rounded-xl border border-[#E5E7EB] bg-[#F9FAFB] p-4">
                  <p className="text-sm font-semibold text-[#111827]">
                    Team project assignment
                  </p>
                  <p className="mt-1 text-sm text-[#6B7280]">
                    TM Name:{" "}
                    <span className="font-medium text-[#111827]">
                      {memberName || "This member"}
                    </span>
                  </p>
                  <FormControlLabel
                    sx={{ mt: 1, alignItems: "flex-start" }}
                    control={
                      <Checkbox
                        checked={assignTeamProjects}
                        onChange={(e) => setAssignTeamProjects(e.target.checked)}
                      />
                    }
                    label="Assign this member to the team's projects"
                  />
                  {assignTeamProjects ? (
                    <div className="mt-2">
                      <div className="mb-2 flex items-center justify-between gap-3">
                        <p className="text-sm text-[#6B7280]">
                          Projects assigned to{" "}
                          {selectedTeam.map((t: any) => t.value).join(", ")}
                        </p>
                        {teamProjects.length > 0 && (
                          <button
                            type="button"
                            className="text-sm font-medium text-[#841C39]"
                            onClick={() => {
                              const allIds = teamProjects.map((row) =>
                                String(row._id)
                              );
                              setSelectedProjectIds(
                                selectedProjectIds.length === allIds.length
                                  ? []
                                  : allIds
                              );
                            }}
                          >
                            {selectedProjectIds.length === teamProjects.length
                              ? "Clear all"
                              : "Select all"}
                          </button>
                        )}
                      </div>
                      {loadingProjects ? (
                        <p className="text-sm text-[#6B7280]">Loading projects...</p>
                      ) : teamProjects.length === 0 ? (
                        <p className="text-sm text-[#6B7280]">
                          No projects are assigned to this team yet.
                        </p>
                      ) : (
                        <div className="grid max-h-56 grid-cols-1 gap-1 overflow-y-auto sm:grid-cols-2">
                          {teamProjects.map((project) => {
                            const id = String(project._id);
                            return (
                              <FormControlLabel
                                key={id}
                                sx={classes.CheckLabel}
                                control={
                                  <Checkbox
                                    checked={selectedProjectIds.includes(id)}
                                    onChange={(e) => {
                                      setSelectedProjectIds((prev) =>
                                        e.target.checked
                                          ? prev.includes(id)
                                            ? prev
                                            : [...prev, id]
                                          : prev.filter((item) => item !== id)
                                      );
                                    }}
                                  />
                                }
                                label={project.project_name || "Untitled project"}
                              />
                            );
                          })}
                        </div>
                      )}
                    </div>
                  ) : (
                    <p className="mt-1 text-sm text-[#6B7280]">
                      This member will join the team without being added to
                      project assignees.
                    </p>
                  )}
                </div>
              )}
            </>
          )}

          <YhSelect
            label="Reporting Manager"
            placeholder="Select team"
            value={officialDetailState?.reportingManagerId?.id || ""}
            options={reportingManagerData.map((manager: any) => ({
              label: manager.label,
              value: manager.id,
            }))}
            onChange={(e) => {
              const selected = reportingManagerData.find(
                (manager: any) => manager.id === e.target.value
              );
              console.log(selected, "sdbfjksdbfkjsdf");
              setofficialDetailState({
                ...officialDetailState,
                reportingManagerId: { id: selected?.id },
                reportingManagerName: { value: selected?.label },
              });
            }}
          />

          <div className="lg:col-span-2">
            <p className="mb-2 text-sm font-medium text-[#111827]">Working Days</p>
            <Box sx={classes.checkBoxPart}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Monday"
                  sx={classes.CheckLabel}
                  checked={(
                    officialDetailState?.working_days?.value || []
                  ).includes(
                    "monday"
                  )}
                  name="monday"
                  onChange={(event: any) =>
                    handleCheckboxChange(event, "working_days")
                  }
                />
              </FormGroup>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Tuesday"
                  sx={classes.CheckLabel}
                  checked={(
                    officialDetailState?.working_days?.value || []
                  ).includes(
                    "tuesday"
                  )}
                  name="tuesday"
                  onChange={(event: any) =>
                    handleCheckboxChange(event, "working_days")
                  }
                />
              </FormGroup>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Wednesday"
                  sx={classes.CheckLabel}
                  checked={(
                    officialDetailState?.working_days?.value || []
                  ).includes(
                    "wednesday"
                  )}
                  name="wednesday"
                  onChange={(event: any) =>
                    handleCheckboxChange(event, "working_days")
                  }
                />
              </FormGroup>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Thursday"
                  sx={classes.CheckLabel}
                  checked={(
                    officialDetailState?.working_days?.value || []
                  ).includes(
                    "thursday"
                  )}
                  name="thursday"
                  onChange={(event: any) =>
                    handleCheckboxChange(event, "working_days")
                  }
                />
              </FormGroup>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Friday"
                  sx={classes.CheckLabel}
                  checked={(
                    officialDetailState?.working_days?.value || []
                  ).includes(
                    "Friday"
                  )}
                  name="Friday"
                  onChange={(event: any) =>
                    handleCheckboxChange(event, "working_days")
                  }
                />
              </FormGroup>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Saturday"
                  sx={classes.CheckLabel}
                  checked={(
                    officialDetailState?.working_days?.value || []
                  ).includes(
                    "saturday"
                  )}
                  name="saturday"
                  onChange={(event: any) =>
                    handleCheckboxChange(event, "working_days")
                  }
                />
              </FormGroup>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Sunday"
                  checked={(
                    officialDetailState?.working_days?.value || []
                  ).includes(
                    "sunday"
                  )}
                  sx={classes.CheckLabel}
                  name="sunday"
                  onChange={(event: any) =>
                    handleCheckboxChange(event, "working_days")
                  }
                />
              </FormGroup>
            </Box>
          </div>

          <div className="mb-2 flex flex-wrap gap-3 lg:col-span-2">
            {props.hideFooterButtons ? null : (
              <>
                <YhButton variant="secondary" onClick={handleBackBtn}>
                  Back
                </YhButton>
                <YhButton variant="primary" onClick={submitForm}>
                  Save & Continue
                </YhButton>
              </>
            )}
          </div>
        </div>

        {apiResponse && <CustomLoader apiResponse={apiResponse} />}
      </div>
      <Dialog
        open={openTeamModal}
        onClose={() => setOpenTeamModal(false)}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="sm"
        fullWidth
        sx={MetaListStyles.radioGroup}
        style={{
          maxWidth: "700px",
          margin: "0 auto",
        }}
      >
        <Typography sx={CustomPageHeaderStyles.heading} p={2}>
          Select Team
        </Typography>
        <Divider />
        <Box
          style={{
            maxHeight: "500px",
            overflowY: "auto",
            padding: "8px",
          }}
        >
          {!teamData || teamData.length === 0 ? (
            <Typography
              variant="body2"
              sx={{ textAlign: "center", color: "#6B7280", py: 4 }}
            >
              {!departmentId
                ? "Please select a department first"
                : "No teams found for this department"}
            </Typography>
          ) : (
            <Box sx={MetaListStyles.radioGroup}>{renderTeams(teamData)}</Box>
          )}
        </Box>
      </Dialog>
      {/* <Dialog
        open={openTeamModal}
        onClose={() => setOpenTeamModal(false)}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="sm"
        fullWidth
        sx={MetaListStyles.radioGroup}
        style={{
          maxWidth: "700px",
          margin: "0 auto",
        }}
      >
        <Typography sx={CustomPageHeaderStyles.heading} p={2}>Select Team</Typography>
        <Divider />
        <Box style={{
          maxHeight: "500px",
          overflowY: "auto",
          padding: "8px",
        }}>
          <RadioGroup value={selectedTeam} sx={MetaListStyles.radioGroup} onChange={(event) => setSelectedTeam(event.target.value)}>
            {renderTeams(teamData)}
          </RadioGroup>

        </Box>
      </Dialog> */}

    </>
  );
};

export default OfficialInformation;
